import { DefaultExposeGroupEnum } from '@goparrot/common';
var CustomExposeGroups;
(function (CustomExposeGroups) {
    CustomExposeGroups["BATCH_CREATE"] = "batch-create";
    CustomExposeGroups["BATCH_PATCH"] = "batch-patch";
    CustomExposeGroups["BATCH_DELETE"] = "batch-delete";
    CustomExposeGroups["REQUEST"] = "request";
})(CustomExposeGroups || (CustomExposeGroups = {}));
export const StoreItemsExposeGroup = Object.freeze({ ...DefaultExposeGroupEnum, ...CustomExposeGroups });
//# sourceMappingURL=StoreItemsExposeGroup.js.map